import React from 'react';
import { Radio, RadioProps } from '@material-ui/core';
import { useStyles } from './RadioButton.styles';

export interface RadioButtonProps extends RadioProps {
  dataQaId?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({ dataQaId, ...props }) => {
  const classes = useStyles();
  return <Radio classes={classes} data-qa-id={`${dataQaId}-radio-button`} {...props} />;
};

export default RadioButton;
